import apiService from '../../../repositories/apiService';

export default {
    getDepthChart({ rootGetters, commit, state }) {
        return new Promise((resolve, reject) => {
            apiService.get(
                '/depth_charts/myDepthCharts',
            )
                .then((response) => {
                    commit('setDepthChart', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit('setError', error);
                    reject(error);
                });
        });
    },
    getDepthChartByPerson(state, payload) {
        return new Promise((resolve, reject) => {
            apiService.get(
                '/depth_charts/depthChartByPerson/',
                {
                    params: {
                        person_id: payload.personId,
                    },
                },
            )
                .then((response) => {
                    state.commit('setDepthChart', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    state.commit('setDepthChart', null);
                    state.commit('setError', error);
                    reject(error);
                });
        });
    }
};
